// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"161":"yearlies","594":"about"}[chunkId] + "." + {"161":"7913d5b4","594":"07f859bb"}[chunkId] + ".css";
};